import moment from 'moment'
import {PlanType} from '../setting-reference/constants'
import {OrderStatus, ItemStatus} from './constants'
import {OrderStatisticModel} from './models/orderSatisticsModel'
import {DATE_ONLY_FORMAT} from '../../shared/constants'
export const orderStatusClassMapping = (orderStatus: OrderStatus) => {
  let statusClass = ''
  switch (orderStatus) {
    case OrderStatus.UPLOADED:
      statusClass = 'badge-light-primary'
      break
    case OrderStatus.PENDING:
      statusClass = 'badge-light-info'
      break
    case OrderStatus.AI_PROCESSING:
      statusClass = 'badge-light-warning'
      break
    case OrderStatus.REJECTED:
      statusClass = 'badge-light-danger'
      break
    case OrderStatus.PROCESSING:
      statusClass = 'badge-light-warning'
      break
    case OrderStatus.COMPLETED:
      statusClass = 'badge-light-success'
      break
    case OrderStatus.AI_FAILED:
      statusClass = 'badge-light-danger'
      break
    default:
      statusClass = 'badge-light-warning'
  }
  return statusClass
}

export const itemStatusClassMapping = (itemStatus: ItemStatus) => {
  let statusClass = ''
  switch (itemStatus) {
    case ItemStatus.UPLOADED:
      statusClass = 'badge-light-primary'
      break
    case ItemStatus.PENDING:
      statusClass = 'badge-light-info'
      break
    case ItemStatus.AI_PROCESSING:
      statusClass = 'badge-light-warning'
      break
    case ItemStatus.DONE:
      statusClass = 'badge-light-success'
      break
    case ItemStatus.FAIL:
      statusClass = 'badge-light-danger'
      break
    default:
      statusClass = 'badge-light-warning'
  }
  return statusClass
}

export const getMaxItemRequestWithUserPlan = (userPlan: PlanType) => {
  switch (userPlan) {
    case PlanType.SUBSCRIPTION_PREMIUM:
      return 100
    case PlanType.SUBSCRIPTION_STANDARD:
      return 50
    case PlanType.SUBSCRIPTION_BASIC:
      return 50
    default:
      return 10
  }
}

export const convertOrderStatisticToChartData = (
  orderStatistic: OrderStatisticModel[],
  intl: any
) => {
  let series: {name: string; data: number[]}[] = []
  if (orderStatistic && orderStatistic.length === 0) {
    return {series, labels: []}
  }
  const labels: string[] = orderStatistic.map((item) => moment(item.date).format(DATE_ONLY_FORMAT))
  const totalNonPaid: number[] = orderStatistic.map((item) => item.totalNonPaid)
  const totalProfessional: number[] = orderStatistic.map((item) => item.totalProfessional)
  const totalAiOnly: number[] = orderStatistic.map((item) => item.totalAiOnly)
  series.push({name: intl.formatMessage({id: 'order.totalNonPaid'}), data: totalNonPaid})
  series.push({name: intl.formatMessage({id: 'order.totalProfessional'}), data: totalProfessional})
  series.push({name: intl.formatMessage({id: 'order.totalAiOnly'}), data: totalAiOnly})
  return {series, labels}
}
